import { Avatar, Skeleton, Typography } from "..";
import { BreifCaseIconWhite, MaximizeWhiteIcon } from "../../../theme/icons2";
import propTypes from "prop-types";
const generateStyleFromFunction = ({ variant, active }) => ({
    bg: active ? `border bg-${variant}-100 border-${variant}-300` : `border bg-${variant}-50 border-${variant}-200`,
    'avatar-bg': `bg-${variant}-300`
})

export const OverviewCards = ({ count = 0, title = "", subTitle = "", variant = "",
    icon = <></>, active = false, onClick = () => null, loading = false, loaderCount = 1 }) => {

    const selectedStyle = generateStyleFromFunction({ variant, active });

    return (<>
        {loading ? Array.from({ length: loaderCount }, (_, i) => i + 1)?.map(item => <Loader key={item} />) :
            <button  tabIndex={count}
                aria-label="Select Card" onClick={onClick}
                className={`${selectedStyle?.bg} cursor-pointer px-4 py-2 rounded-lg flex flex-col gap-2 items-center w-full`}>
                <div className='gap-2 flex items-center w-full p-2 border-b pb-2 border-secondary-200'>
                    <Avatar alt={"Single Overview"} className={selectedStyle?.['avatar-bg']}
                        src={icon} />
                    <div>
                        <Typography variant="2xl" text={count} className="font-semibold text-left" />
                        <Typography variant="sm" text={title} className="text-secondary-400 font-semibold h-[33px]" />
                    </div>
                </div>
                <div className='flex items-center gap-4 px-4 py-1 justify-start w-full'>
                    <BreifCaseIconWhite stroke="#677A8E" />
                    <Typography variant="sm" text={subTitle} className="font-thin" />
                </div>
            </button>}
    </>
    )
}

const Loader = () => (
    <div className={`border bprder-secondary-200 px-4 py-2 rounded-lg flex flex-col gap-2 items-center w-full`}>
        <div className='gap-2 flex items-center w-full p-2 border-b pb-4 border-secondary-200'>
            <Avatar alt={"Single Overview"} className={'bg-secondary-200'}
                src={<MaximizeWhiteIcon className="m-auto h-[20px] w-[20px] flex justify-center items-center" />} />
            <div className='w-full flex flex-col gap-2'>
                <Skeleton length={1} className="h-6 w-full rounded-md" />
                <Skeleton length={1} className="h-3 w-full ounded-md" />
            </div>
        </div>
        <div className='flex items-center gap-4 px-4 py-1 justify-start w-full'>
            <BreifCaseIconWhite stroke="#677A8E" />
            <Skeleton length={1} className="h-3 w-full ounded-md" />
        </div>
    </div>
)

OverviewCards.propTypes = {
    count: propTypes.number,
    title: propTypes.string,
    subTitle: propTypes.string,
    variant: propTypes.string,
    icon: propTypes.element,
    active: propTypes.bool,
    onClick: propTypes.func,
    loading: propTypes.bool,
    loaderCount: propTypes.number
}